import React from 'react';

import type { Props } from './types';

import LayoutNirmalx from 'ui/nirmalx/layout/LayoutNirmalx';

// NirmalX: every page uses the NirmalX shell (ui/nirmalx/layout) in place of Blockscout's sidebar layout.
const LayoutDefault = ({ children }: Props) => <LayoutNirmalx>{ children }</LayoutNirmalx>;

export default LayoutDefault;
